<template>
  <section class="content" style="padding:unset;">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 serch-barr">

        <div class="row">
          <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <p class="home-topic" style="padding-top: 11%;">Videos</p>
          </div>
          <div class="col-3 col-sm-3 col-md-6 col-lg-6 col-xl-6">

            <div class="searchBar" style="padding-top: 3%;">
              <input type="text" v-model="searchField" v-on:keyup.enter="getVideos"  class="searchTerm" placeholder="What are you looking for?">
              <button type="submit" class="searchButton">
                <i class="fa fa-search" @click="getVideos"></i>
              </button>
            </div>
          </div>
          <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
            <md-field class="dddBox">
              <md-select class="dropDown"  name="orderBy" id="orderBy" v-model="selectOrderBySelected" placeholder="Sort Videos" @md-selected="getVideos('searching')">
                <md-option :value="cata.value" v-for="cata in selectOrderBy" v-bind:key="cata.value" >{{cata.desc}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
            <md-field class="dddBox">
              <md-select class="dropDown"  name="category" id="category" v-model="selectCata" placeholder="All Categories" @md-selected="getVideos('searching')">
                <md-option :value="'all'">
                  All Categories
                </md-option>
                <md-option :value="cata.id" v-for="cata in allCata" v-bind:key="cata.id" >{{cata.name}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <!-- <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
            <md-field class="dddBox">
              <md-select class="dropDown" name="products" id="products" v-model="selectProduct" placeholder="All Products" @md-selected="getVideos('searching')">
                <md-option :value="'all'">
                  All Products
                </md-option>
                <md-option :value="cata.id" v-for="cata in allProduct" v-bind:key="cata.id" >{{cata.name}}
                </md-option>
              </md-select>
            </md-field>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row" v-if="!allVideos.hasOwnProperty('status')">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="video in allVideos" v-bind:key="video.id">
            <div class="sg-str" @click="favoritVideo(video.id, video.favourite)">
              <i :id="video.id" :class="[video.favourite=='yes'?'fa fa-star':'fa fa-star-o']" aria-hidden="true">
              </i>
            </div>

              <div class="v-boxx">
                <router-link :to="'/videos/single-video/'+video.category_id+'/'+video.id">
                <div class="v-videoo">
                  <img :src='video.thumbnail_large'  alt="...">
                </div>
                </router-link>
                <div class="v-content">
                  <div class="qr-bar">
                      <div class="qr-body">
                        <ejs-tooltip id="tooltip" position='BottomCenter' content="Print QR code" target="#target">
                          <button id='target' class="cart-btnn" @click="qrGenarater(video.id, video.qr_code, video.qr_url)"><i style="font-size: 22px;padding: 7px 5px 5px 5px;" class="fa fa-qrcode" aria-hidden="true"></i></button>
                        </ejs-tooltip>
                      </div>
                  </div>
                  <router-link :to="'/videos/single-video/'+video.category_id+'/'+video.id">
                  <p class="v-name two-line-overflow">{{video.name}}</p>
                  <!-- <ul class="v-name two-line-overflow2" style="padding-left:0;" >
                    <li class="badge bgg-pr"  v-for="product in video.products" v-bind:key="product.id">
                      {{product.pro_name}}
                    </li>
                  </ul> -->
                  <p class="v-disc two-line-overflow">{{video.description}}</p>
                  </router-link>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="noContent==='yes'">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        No results found
      </div>
    </div>
    <div class="row" v-if="noContentErrorMsg">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="100">
        <rect x="0" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="0" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="0" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="25%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="25%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="25%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="51%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="51%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="51%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="77%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="77%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="77%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="84" rx="2" ry="2" width="23%" height="3"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>

<!--    <div class="row">-->
<!--      <scroll-loader :loader-method="getVideos" :loader-enable="this.loaderEnable">-->
<!--      </scroll-loader>-->
<!--    </div>-->
    <div class="row">
      <div style="float: right;" v-if="allVideos.length!=0">
        <ul class="pagination">
          <li v-bind:class="{disable:pagination.current_page===pagination.from}" class="page-item">
            <a
              @click="pagination.current_page!==pagination.from && getUpdateVideosWithPagination(pagination.first_page_url)"
              class="page-link"
            >&laquo;</a>
          </li>
          <li v-bind:class="{disable:!pagination.prev_page_url}" class="page-item">
            <a @click="pagination.current_page!==pagination.from && getUpdateVideosWithPagination(pagination.prev_page_url)" class="page-link">&lt;</a>
          </li>
          <li
            v-for="n in pagination.last_page"
            v-bind:key="n"
            v-bind:class="{active:pagination.current_page == n}"
            class="page-item"
          >
            <a
              @click="pagination.current_page!==n && getUpdateVideosWithPagination(pagination.path + '?page=' + n)"
              class="page-link"
            >{{n}}</a>
          </li>
          <li v-bind:class="{disable:!pagination.next_page_url}" class="page-item">
            <a @click="pagination.current_page!==pagination.last_page && getUpdateVideosWithPagination(pagination.next_page_url)" class="page-link">&gt;</a>
          </li>
          <li v-bind:class="{disable:!pagination.last_page_url}" class="page-item">
            <a
              @click="pagination.current_page!==pagination.last_page && getUpdateVideosWithPagination(pagination.last_page_url)"
              class="page-link"
            >&raquo;</a>
          </li>
        </ul>
      </div>
    </div>
    <back-to-top bottom="120px" right="20px" visibleoffset="20">
      <button type="button" class="scoller-top-btn"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>

    <div style="text-align: center; display: none" id="printSection">
          <div v-if="haveQR">
            <div>
            <vue-qr :bgSrc='src' :logoSrc="src2" :correctLevel='3' :logoScale='0.3' :dotScale='0.90' :callback="generateQRimageURL" qid="testid"  :text="qrRef"  :size="400"></vue-qr>
            </div>
          </div>
          <div v-else>
            <img :src="'https://smartapprcp.s3-ap-southeast-1.amazonaws.com/'+ this.qrcode.qr_url" alt="QR Image">
          </div>
    </div>

     <!-- ================== QR Modal ================== -->
     <!-- <md-dialog :md-active.sync="qrModal" class="model-show" style="width: 500px; display:none">
      <md-dialog-title class="model-title">QR Control
        <a style="float: right;cursor: pointer;" class="md-primary" @click="qrModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding">

        </form>
      <md-dialog-actions class="model-foot">
         <sync-loader :loading="editModalLoading" :color="editModalColor" :size="editModalSize"
            :width="editModalWidth" :margin="editModalMargin"></sync-loader>
             &nbsp;&nbsp;&nbsp;
            <button type="button" class="btn primary-btn-my" @click="uploadQrCode" v-if="haveQR">
              Generate QR
            </button>
            <button type="button" class="btn primary-btn-my" @click="printQR" v-else>
              Print QR
            </button>
      </md-dialog-actions>
    </md-dialog> -->

  </section>
</template>
<script>
  import AWS from 'aws-sdk'
  AWS.config.region = 'ap-southeast-1' // 1. Enter your region

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'ap-southeast-1:d3a76794-ef80-4000-a846-afb95dc782f3' // 2. Enter your identity pool
  })

  AWS.config.credentials.get(function(err) {
    if (err) alert(err)
  })

  var bucketName = 'smartapprcp' // Enter your bucket name
  var bucket = new AWS.S3({
    params: {
      Bucket: bucketName
    }
  })
  import api from '../../../api'
  import dropdown from 'vue-dropdowns'
  import Alert from '../../widgets/Alert'
  import InfoBox from '../../widgets/InfoBox'
  import ProcessInfoBox from '../../widgets/ProcessInfoBox'
  import SmallBox from '../../widgets/SmallBox'
  import BackToTop from 'vue-backtotop'

  var SyncLoader = require('vue-spinner/src/SyncLoader')
  import VueQr from 'vue-qr'
  import VueContentLoading from 'vue-content-loading'
  import Vue from 'vue'

  export default {
    name: 'homeView',
    components: {
      'SyncLoader': SyncLoader,
      Alert,
      InfoBox,
      ProcessInfoBox,
      SmallBox,
      'dropdown': dropdown,
      VueContentLoading,
      BackToTop,
      VueQr
    },
    data() {
      return {
        haveQR: false,
        qrRef: '',
        qrRefImage: '',
        src: '',
        src2: '/static/img/crp-images/QR-LOGO.png',
        qrModal: false,
        qrcode: {
          video_id: '',
          qr_code: '',
          qr_url: ''
        },
        editModalColor: '#FECD2F',
        editModalSize: '10px',
        editModalLoading: false,
        editModalHeight: '35px',
        editModalWidth: '5px',
        editModalMargin: '2px',
        editModalRadius: '2px',
        page: 0,
        pageSize: 10,
        loaderEnable: true,
        selectCata: '',
        selectProduct: '',
        selectOrderBySelected: '',
        allCata: [],
        allProduct: [],
        allVideos: [],
        searchField: '',
        noContent: 'no',
        noContentErrorMsg: true,
        pagination: {},
        favList: [],
        selectOrderBy: [
          {
            id: 1,
            value: 'numeric_asc',
            name: 'numeric',
            type: 'asc',
            desc: 'A to Z'
          },
          {
            id: 2,
            value: 'numeric_desc',
            name: 'numeric',
            type: 'desc',
            desc: 'Z to A'
          },
          {
            id: 3,
            value: 'date_asc',
            name: 'date',
            type: 'asc',
            desc: 'New to Old'
          },
          {
            id: 4,
            value: 'date_desc',
            name: 'date',
            type: 'desc',
            desc: 'Old to New'
          }
        ]
      }
    },
    methods: {
      printQR() {
        this.$htmlToPaper('printSection')
      },
      generateQRimageURL(dataUrl) {
        this.qrRefImage = dataUrl
      },
      uploadQrCode() {
        var ref = this
        function urltoFile(url, filename, mimeType) {
          return fetch(url)
            .then(function(res) {
              return res.arrayBuffer()
            })
            .then(function(buf) {
              return new File([buf], filename, { type: mimeType })
            })
        }
        var imgName = this.qrRef + '.png'
        var path = 'rcp_qr/' + imgName
        this.qrcode.qr_url = path
        this.qrcode.qr_code = this.qrRef
        urltoFile(this.qrRefImage, imgName).then(function(file) {
          var objKey = 'rcp_qr/' + file.name
          var params = {
            Key: objKey,
            ContentType: 'image/png',
            Body: file,
            ACL: 'public-read'
          }
          bucket.putObject(params, function(err, data) {
            if (err) {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: err})
            } else {
              console.log('Done')
              ref.qrUpdataDB()
            }
          })
        })
      },
      qrUpdataDB() {
        // var ref = this
        api.request('post', '/admin/videos/store_qrcode', this.qrcode)
          .then(response => {
            if (response.status === 200) {
              this.haveQR = false
              this.printQR()
              setTimeout(() => (this.getVideos()), 2000)
              // this.qrModal = false
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      qrGenarater(id, code, url) {
        this.qrcode.video_id = id
        this.qrcode.qr_code = code
        this.qrcode.qr_url = url
        if (this.qrcode.qr_code === null || this.qrcode.qr_code === '') {
          this.haveQR = true
          this.qrRefNumber()
          setTimeout(() => (this.uploadQrCode()), 2000)
          // this.uploadQrCode()
        } else {
          this.haveQR = false
          setTimeout(() => (this.printQR()), 2000)
        }
      },
      qrRefNumber() {
        var randomMathName = Math.floor(Math.random() * 100000000000)
        this.qrRef = 'rb_' + randomMathName
        console.log(this.qrRef)
      },
      getAllCata() {
        api.request('get', '/admin/categories/select ')
          .then(response => {
            this.allCata = response.data.result
          })
      },
      getAllProduct() {
        api.request('get', '/customer/productList')
          .then(response => {
            this.allProduct = response.data.products
          })
      },
      favoritVideo(id, type) {
        if (this.favList.length === 0) {
          this.favList.push(id + '-' + type)
          if (type === 'no') {
            document.getElementById(id).className = 'fa fa-star'
          } else {
            document.getElementById(id).className = 'fa fa-star-o'
          }
        } else {
          var b = true
          for (let x = 0; x < this.favList.length; x++) {
            var y = this.favList[x].split('-')
            if (y[0] === '' + id) {
              var tt = null
              if (y[1] === 'yes') {
                tt = 'no'
              } else {
                tt = 'yes'
              }
              if (tt === 'no') {
                document.getElementById(id).className = 'fa fa-star'
              } else {
                document.getElementById(id).className = 'fa fa-star-o'
              }
              b = false
              this.favList.splice(this.favList[x], 1)
            }
          }
          if (b) {
            this.favList.push(id + '-' + type)
            if (type === 'no') {
              document.getElementById(id).className = 'fa fa-star'
            } else {
              document.getElementById(id).className = 'fa fa-star-o'
            }
          }
        }
        // console.log(this.favList)
        this.favouriteBackendCall('videos', id)
      },
      favoritDocument(id) {
        this.favouriteBackendCall('documents', id)
      },
      favouriteBackendCall(mediaType, id) {
        api.request('get', '/customer/favourite/' + mediaType + '/' + id)
          .then(response => {
            // this.getVideos2()
          })
      },
      getVideos(initCatId) {
        var ref = this
        var catId = ref.selectCata
        var productId = ref.selectProduct
        // var selectOrderBySelected = ref.selectOrderBySelected
        var paramSelectOrderBySelected = ''
        var search = ref.searchField
        var deviceType = 'm'
        ref.noContent = 'no'
        ref.noContentErrorMsg = true
        ref.allVideos = []
        if (initCatId && initCatId > 0 && initCatId !== 'searching') {
          ref.selectCata = initCatId
          catId = initCatId
        }
        if (ref.selectCata === null || ref.selectCata === '' || !ref.selectCata) {
          catId = 'all'
          ref.selectCata = 'all'
        }
        if (ref.selectProduct === null || ref.selectProduct === '' || !ref.selectProduct) {
          productId = 'all'
          ref.selectProduct = 'all'
        }
        if (ref.searchField === null || ref.searchField === '' || !ref.searchField) {
          search = 'all'
        }
        if (ref.selectOrderBySelected !== undefined || ref.selectOrderBySelected !== '' || ref.selectOrderBySelected) {
          paramSelectOrderBySelected = ref.selectOrderBySelected
        }
        var url = '/customer/search/videos/' + catId + '/' + productId + '/' + deviceType + '?search_key=' + search + '&orderby=' + paramSelectOrderBySelected
        api.request('get', url)
          // api.request('get', '/customer/videos/' + catId + '/' + productId + '/' + search + '/' + deviceType)
          .then(response => {
            if (response.data.result.hasOwnProperty('status') && response.data.result.status === 'error') {
              ref.noContent = 'yes'
            }
            this.allVideos = response.data.result
            this.pagination = response.data.pagination
            this.noContentErrorMsg = false
            ref.loaderEnable = false
          })
      },
      getUpdateVideosWithPagination(pegination) {
        var ref = this
        var url = pegination
        api.httpRequestCore({method: 'get', url: url, headers: { Authorization: 'Bearer ' + Vue.auth.getToken() }})
          .then(response => {
            if (response.data.result.hasOwnProperty('status') && response.data.result.status === 'error') {
              ref.noContent = 'yes'
            }
            this.allVideos = response.data.result
            this.pagination = response.data.pagination
            this.noContentErrorMsg = false
            ref.loaderEnable = false
          })
      }
    },
    mounted() {},
    created() {
      this.getAllCata()
      this.getAllProduct()
      this.getVideos(this.$route.query.cat)
    }
  }
</script>
<style>
  @media (min-width: 320px) and (max-width: 480px) {
    .video-list-thumbs .glyphicon-play-circle {
      font-size: 35px;
      right: 36%;
      top: 27%;
    }

    .video-list-thumbs h2 {
      bottom: 0;
      font-size: 12px;
      height: 22px;
      margin: 8px 0 0;
    }
  }

  .top-right {
    position: absolute;
    top: 8px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// UserVideos.vue?c4b7f4ce